import { MessageBox } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import { WorkTableType } from '../../../services/commands/UserInteractor';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getWorkTableState } from '../../../store/selectors/workTable';
import dataset, { DatasetSwitchEffect } from '../../../store/slices/dataset';
import workTable, {
  OpenWorkTablePostEffectType,
} from '../../../store/slices/workTable';

import WorkTable from './WorkTable';

const useStyles = createUseStyles({
  dialog: {
    minWidth: 600,
    maxWidth: '98vw',
  },
});

const messages = defineMessages({
  plan: { id: 'core.worktable.typePlan', defaultMessage: 'Plan' },
  fact: { id: 'core.worktable.typeFact', defaultMessage: 'Fact' },
  calendar: { id: 'core.worktable.typeCalendar', defaultMessage: 'Calendar' },
  timeBoard: { id: 'core.worktable.timeBoard', defaultMessage: 'Time Board' },
  next: {
    id: 'core.form.next',
    defaultMessage: 'Next',
  },
  prev: {
    id: 'core.form.prev',
    defaultMessage: 'Previous',
  },
  format: {
    id: 'core.worktable.format',
    defaultMessage: 'Format',
  },
  ok: {
    id: 'core.form.ok',
    defaultMessage: 'Ok',
  },
  cancel: {
    id: 'ui.button.cancel',
    defaultMessage: 'Cancel',
  },
});

const WorkTableDialog = (): React.JSX.Element | null => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const table = useAppSelector(getWorkTableState);
  const { workerId, show, datasetId, tableType } = table;

  if (!show) {
    return null;
  }

  const next = formatMessage(messages.next);
  const prev = formatMessage(messages.prev);
  const format = formatMessage(messages.format);
  const ok = formatMessage(messages.ok);
  const cancel = formatMessage(messages.cancel);

  return (
    <MessageBox
      open
      resizable
      title={formatMessage(messages[tableType])}
      onClose={() => dispatch(workTable.close())}
      className={classes.dialog}
      noChildrenWrap
    >
      <MessageBox.Content>
        <WorkTable workerId={workerId} table={table} />
      </MessageBox.Content>
      <MessageBox.Footer>
        <MessageBox.Button
          label={prev}
          onClick={() =>
            dispatch(
              dataset.selectPreviousRecord({
                datasetId,
                effect: DatasetSwitchEffect.WORK_TIMES,
              })
            )
          }
        />
        <MessageBox.Button
          label={next}
          onClick={() =>
            dispatch(
              dataset.selectNextRecord({
                datasetId,
                effect: DatasetSwitchEffect.WORK_TIMES,
              })
            )
          }
        />
        {table.tableType !== WorkTableType.CALENDAR &&
          table.tableType !== WorkTableType.TIME_BOARD && (
            <MessageBox.Button
              label={format}
              onClick={() =>
                dispatch(
                  workTable.open({
                    datasetId,
                    tableType,
                    effect: {
                      type: OpenWorkTablePostEffectType.FORMAT,
                      workerId,
                    },
                  })
                )
              }
            />
          )}
        <MessageBox.Button
          type="submit"
          label={ok}
          onClick={() => dispatch(workTable.update())}
        />
        <MessageBox.Button
          label={cancel}
          onClick={() => dispatch(workTable.close())}
        />
      </MessageBox.Footer>
    </MessageBox>
  );
};

export default WorkTableDialog;
